module.exports = __webpack_public_path__ + "img/content-writing.3de9266d.jpg";